import API_BASE from '../config';
import { useState, useEffect } from 'react';

export function PromptPicker({ type, onSelect }) {
  const [prompts, setPrompts] = useState([]);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    fetch(`${API_BASE}/prompts`)
      .then(r => r.json())
      .then(data => {
        const filtered = type ? data.filter(p => p.prompt_type === type) : data;
        setPrompts(filtered);
      })
      .catch(() => {});
  }, [type]);

  if (prompts.length === 0) return null;

  return (
    <div style={{ position: 'relative', display: 'inline-block' }}>
      <button
        onClick={() => setOpen(!open)}
        style={{ background: '#2a3d2e', border: '1px solid #4a7c59', borderRadius: '4px', color: '#a3b89a', fontSize: '0.78rem', padding: '0.3rem 0.75rem', cursor: 'pointer' }}
      >
        Use saved prompt
      </button>
      {open && (
        <div style={{ position: 'absolute', top: '100%', left: 0, zIndex: 100, backgroundColor: '#1a1d16', border: '1px solid #2a2d24', borderRadius: '6px', minWidth: '280px', maxHeight: '220px', overflowY: 'auto', marginTop: '0.25rem', boxShadow: '0 4px 12px rgba(0,0,0,0.4)' }}>
          {prompts.map(p => (
            <div
              key={p.id}
              onClick={async () => {
                onSelect(p.prompt_text);
                setOpen(false);
                await fetch(`${API_BASE}/prompts/${p.id}/use`, { method: 'POST' });
              }}
              style={{ padding: '0.65rem 1rem', cursor: 'pointer', borderBottom: '1px solid #2a2d24' }}
              onMouseEnter={e => e.currentTarget.style.backgroundColor = '#2a3d2e'}
              onMouseLeave={e => e.currentTarget.style.backgroundColor = 'transparent'}
            >
              <p style={{ margin: 0, fontSize: '0.82rem', fontWeight: '600', color: 'white' }}>{p.title}</p>
              {p.sector_tag && <p style={{ margin: '0.1rem 0 0', fontSize: '0.72rem', color: '#6b7566' }}>{p.sector_tag}</p>}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
